import axios from "axios";

const Api = axios.create({
    //baseURL : `${global.config.live_url}/api`,
    baseURL : `https://menastockinstore.com/api`,
});

// Add an interceptor for all requests

Api.interceptors.request.use( config => {
    const accessToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzcwNjkwOTM2LCJpYXQiOjE3NjgwOTg5MzYsImp0aSI6ImE2NGQ3NWUyNmEwOTQ2Y2E4NTA1NmIxNDY1ODFjYWJjIiwidXNlcl9pZCI6MX0.M_1MtAwgakjiHg-ucv9eYpdGx8vCENMF7t2ymJJFgv0";
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;

});
export default Api;